export default "__VITE_ASSET__BFFQAC1M__"